import { render, staticRenderFns } from "./KalustoView.vue?vue&type=template&id=5308b258&scoped=true"
import script from "./KalustoView.vue?vue&type=script&lang=js"
export * from "./KalustoView.vue?vue&type=script&lang=js"
import style0 from "./KalustoView.vue?vue&type=style&index=0&id=5308b258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5308b258",
  null
  
)

export default component.exports